var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "ams-info", attrs: { id: "tab-ams" } },
    [
      _vm.showCodeSearch
        ? _c("div", { staticClass: "section operations" }, [
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.cooperateEdit,
                    expression: "cooperateEdit"
                  }
                ],
                staticClass: "triggers"
              },
              [
                _c(
                  "div",
                  [
                    _c(
                      "el-dropdown",
                      {
                        class: _vm.readonly ? "not-click" : "",
                        staticStyle: { "padding-left": "5px" },
                        attrs: { "split-button": "", type: "primary", no: "1" },
                        on: {
                          click: function($event) {
                            return _vm.commandHandle(_vm.command1)
                          },
                          command: function(p) {
                            _vm.command1 = p
                            _vm.commandHandle(_vm.command1)
                          }
                        }
                      },
                      [
                        _vm._v(
                          " " + _vm._s(this.getItemTitle(_vm.command1)) + " "
                        ),
                        _c(
                          "el-dropdown-menu",
                          { attrs: { slot: "dropdown" }, slot: "dropdown" },
                          [
                            _c(
                              "el-dropdown-item",
                              {
                                attrs: {
                                  command: "Copy Last Time",
                                  title: _vm.$t("SeaExport.CopyLast")
                                }
                              },
                              [
                                _vm._v(
                                  _vm._s(this.getItemTitle("Copy Last Time"))
                                )
                              ]
                            ),
                            _c(
                              "el-dropdown-item",
                              {
                                attrs: {
                                  command: "Copy By File NO",
                                  title: _vm.$t("SeaExport.WaybillNumberCopy")
                                }
                              },
                              [
                                _vm._v(
                                  _vm._s(this.getItemTitle("Copy By File NO"))
                                )
                              ]
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm.isJs
                      ? _c(
                          "el-radio-group",
                          {
                            staticStyle: { "margin-left": "20px" },
                            model: {
                              value: _vm.saveAs,
                              callback: function($$v) {
                                _vm.saveAs = $$v
                              },
                              expression: "saveAs"
                            }
                          },
                          [
                            _c("el-radio", { attrs: { label: "1" } }, [
                              _vm._v(_vm._s(_vm.$t("SeaExport.CargoWare")))
                            ]),
                            _c("el-radio", { attrs: { label: "2" } }, [
                              _vm._v(_vm._s(_vm.$t("SeaExport.Other")))
                            ])
                          ],
                          1
                        )
                      : _vm._e()
                  ],
                  1
                )
              ]
            )
          ])
        : _vm._e(),
      _c("div", { staticStyle: { width: "fit-content" } }, [
        _c(
          "div",
          { staticStyle: { display: "flex" } },
          [
            !_vm.showISF
              ? _c("address-format-form", {
                  attrs: {
                    job: _vm.job,
                    "show-second-notify-party": _vm.showSecondNotifyParty,
                    readonly: _vm.readonly,
                    "local-data": _vm.localData,
                    "address-form": _vm.form.afrAddress[0] || {},
                    "tab-name": _vm.tabName,
                    "is-js": _vm.isJs,
                    "js-send-hide": _vm.jsSendHide
                  },
                  on: {
                    showSenderAndReceiverDialog:
                      _vm.showSenderAndReceiverDialog,
                    selectionItemHandlerByType: function(p) {
                      _vm.pm.selectionItemHandlerByType(p)
                    }
                  }
                })
              : _vm._e(),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: !_vm.showISF,
                    expression: "!showISF"
                  }
                ],
                staticClass: "section form-column"
              },
              [
                _c(
                  "el-form",
                  {
                    staticStyle: { height: "100%" },
                    attrs: {
                      disabled: _vm.readonly,
                      "label-width": "112px",
                      "label-position": "right"
                    }
                  },
                  [
                    _c(
                      "span",
                      {
                        staticClass: "title",
                        attrs: { title: _vm.$t("SeaExport.CargoInformation") }
                      },
                      [_vm._v(_vm._s(_vm.getItemTitle("Cargo Information")))]
                    ),
                    _c(
                      "el-form-item",
                      {
                        class: _vm.isDifferent("quantity"),
                        attrs: {
                          title: _vm.$t("SeaExport.BillOfLadingQuantity"),
                          label: _vm.getItemTitle("Quantity")
                        }
                      },
                      [
                        _c("auto-number-input", {
                          attrs: { precision: 0, min: 0, no: "2" },
                          model: {
                            value: _vm.form.quantity,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "quantity", $$v)
                            },
                            expression: "form.quantity"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        class: _vm.isDifferent("packing"),
                        attrs: {
                          title: _vm.$t("SeaExport.Packing"),
                          label: _vm.getItemTitle("Unit Type")
                        }
                      },
                      [
                        _c(
                          "span",
                          { attrs: { slot: "label" }, slot: "label" },
                          [
                            _c(
                              "el-tooltip",
                              {
                                attrs: {
                                  content: _vm.$t(
                                    "CargoMsg.Cargo_AmsUnitTypeTip"
                                  ),
                                  placement: "right-end"
                                }
                              },
                              [
                                _c("i", {
                                  staticClass: "el-icon-question",
                                  staticStyle: {
                                    cursor: "pointer",
                                    color: "#1F75D5"
                                  }
                                })
                              ]
                            ),
                            _vm._v(
                              " " + _vm._s(_vm.getItemTitle("Unit Type")) + " "
                            )
                          ],
                          1
                        ),
                        _c("cargo-packing-select", {
                          staticStyle: { width: "100%" },
                          attrs: { "default-value": _vm.form.packing, no: "3" },
                          on: { change: _vm.changeUnitType }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          title: _vm.$t("SeaExport.GrossWeight"),
                          label: _vm.getItemTitle("Gross Weight")
                        }
                      },
                      [
                        _c(
                          "div",
                          { staticStyle: { display: "flex" } },
                          [
                            _c("el-input-number", {
                              class: _vm.isDifferent("weight"),
                              staticStyle: { flex: "1" },
                              attrs: {
                                precision: _vm.jsSendHide ? 0 : 3,
                                controls: false,
                                no: "4"
                              },
                              model: {
                                value: _vm.form.weight,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "weight", $$v)
                                },
                                expression: "form.weight"
                              }
                            }),
                            _c("span", [_vm._v("KGS")])
                          ],
                          1
                        )
                      ]
                    ),
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          title: _vm.$t("SeaExport.Cubage"),
                          label: _vm.getItemTitle("Volume")
                        }
                      },
                      [
                        _c(
                          "div",
                          { staticStyle: { display: "flex" } },
                          [
                            _c("el-input-number", {
                              class: _vm.isDifferent("cubage"),
                              staticStyle: { flex: "1" },
                              attrs: {
                                precision: _vm.jsSendHide ? 0 : 3,
                                controls: false,
                                no: "5"
                              },
                              model: {
                                value: _vm.form.cubage,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "cubage", $$v)
                                },
                                expression: "form.cubage"
                              }
                            }),
                            _c("span", [_vm._v("CBM")])
                          ],
                          1
                        )
                      ]
                    ),
                    _vm.jsSendHide && (_vm.isAms || _vm.isAci)
                      ? _c(
                          "el-form-item",
                          { attrs: { label: _vm.getItemTitle("Cargo Type") } },
                          [
                            _c(
                              "el-select",
                              {
                                attrs: { no: "50" },
                                model: {
                                  value: _vm.form.goodsType,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "goodsType", $$v)
                                  },
                                  expression: "form.goodsType"
                                }
                              },
                              [
                                _c("el-option", {
                                  attrs: {
                                    label: _vm.getItemTitle("General Cargo"),
                                    value: 0
                                  }
                                }),
                                _c("el-option", {
                                  attrs: {
                                    label: _vm.getItemTitle("Dangerous Cargo"),
                                    value: 1
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm.jsSendHide && _vm.isAms && _vm.isDangerousCargo
                      ? _c(
                          "el-form-item",
                          {
                            attrs: { label: _vm.getItemTitle("Hazardous code") }
                          },
                          [
                            _c("el-input", {
                              attrs: { no: "51" },
                              model: {
                                value: _vm.form.hazardousCode,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "hazardousCode", $$v)
                                },
                                expression: "form.hazardousCode"
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm.jsSendHide && _vm.isAms && _vm.isDangerousCargo
                      ? _c(
                          "el-form-item",
                          { attrs: { label: _vm.getItemTitle("Flashpoint") } },
                          [
                            _c(
                              "div",
                              { staticStyle: { display: "flex" } },
                              [
                                _c("el-input-number", {
                                  staticStyle: { flex: "1" },
                                  attrs: {
                                    precision: _vm.jsSendHide ? 0 : 3,
                                    controls: false,
                                    no: "52"
                                  },
                                  model: {
                                    value: _vm.form.flashPointTemp,
                                    callback: function($$v) {
                                      _vm.$set(_vm.form, "flashPointTemp", $$v)
                                    },
                                    expression: "form.flashPointTemp"
                                  }
                                }),
                                _c("span", [_vm._v("℃")])
                              ],
                              1
                            )
                          ]
                        )
                      : _vm._e(),
                    _c(
                      "el-form-item",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value:
                              _vm.jsSendHide &&
                              _vm.isAci &&
                              _vm.isDangerousCargo,
                            expression:
                              "jsSendHide && isAci && isDangerousCargo"
                          }
                        ],
                        attrs: { label: _vm.getItemTitle("Hazardous code") }
                      },
                      [
                        _c("el-input", {
                          attrs: { no: "55" },
                          model: {
                            value: _vm.form.undgCode,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "undgCode", $$v)
                            },
                            expression: "form.undgCode"
                          }
                        })
                      ],
                      1
                    ),
                    !_vm.jsSendHide
                      ? _c(
                          "el-form-item",
                          {
                            class: _vm.isDifferent("containerLoadType"),
                            attrs: {
                              title: _vm.$t("SeaExport.FLCLType"),
                              label: _vm.getItemTitle("Consignment Type")
                            }
                          },
                          [
                            _c(
                              "el-select",
                              {
                                attrs: {
                                  placeholder: _vm.$t("SeaExport.PleaseChoose"),
                                  no: "6"
                                },
                                model: {
                                  value: _vm.form.containerLoadType,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "containerLoadType", $$v)
                                  },
                                  expression: "form.containerLoadType"
                                }
                              },
                              _vm._l(_vm.consignmentTypes, function(
                                item,
                                index
                              ) {
                                return _c("el-option", {
                                  key: index,
                                  attrs: { label: item, value: item }
                                })
                              }),
                              1
                            )
                          ],
                          1
                        )
                      : _vm._e(),
                    _c(
                      "el-form-item",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.tabName === "eManifest",
                            expression: "tabName === 'eManifest'"
                          }
                        ],
                        attrs: {
                          title: _vm.$t("SeaExport.CustomerType"),
                          label: _vm.getItemTitle("Customer Type")
                        }
                      },
                      [
                        _c(
                          "el-select",
                          {
                            attrs: {
                              placeholder: _vm.$t("SeaExport.PleaseChoose"),
                              no: "7"
                            },
                            model: {
                              value: _vm.form.customerType,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "customerType", $$v)
                              },
                              expression: "form.customerType"
                            }
                          },
                          _vm._l(_vm.customerTypes, function(item, index) {
                            return _c("el-option", {
                              key: index,
                              attrs: { label: item, value: item }
                            })
                          }),
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.tabName === "eManifest",
                            expression: "tabName === 'eManifest'"
                          }
                        ],
                        attrs: {
                          label: _vm.getItemTitle("HTS CODE"),
                          title: _vm.$t("SeaExport.HTSCode")
                        }
                      },
                      [
                        _c("el-input", {
                          attrs: { no: "8" },
                          model: {
                            value: _vm.form.htsCode,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "htsCode", $$v)
                            },
                            expression: "form.htsCode"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          "label-width": "0",
                          title: _vm.$t("SeaExport.EnglishCommodityName")
                        }
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(_vm.getItemTitle("Commodity Decription"))
                          )
                        ])
                      ]
                    ),
                    _c(
                      "el-form-item",
                      {
                        staticClass: "auto-width",
                        attrs: { "label-width": "0" }
                      },
                      [
                        _c("cargo-rich-textarea", {
                          class: _vm.isDifferent("cargoEnglishName"),
                          staticStyle: { height: "110px" },
                          attrs: {
                            disabled: !_vm.isEdit,
                            "text-chars": 0,
                            "wrap-symbol": "r",
                            "auto-uppercase": "",
                            "auto-half-word": "",
                            "warning-count": -1,
                            no: "9"
                          },
                          model: {
                            value: _vm.form.cargoEnglishName,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "cargoEnglishName", $$v)
                            },
                            expression: "form.cargoEnglishName"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          "label-width": "0",
                          title: _vm.$t("SeaExport.ShippingMark")
                        }
                      },
                      [_c("span", [_vm._v(_vm._s(_vm.getItemTitle("Marks")))])]
                    ),
                    _c(
                      "el-form-item",
                      {
                        staticClass: "auto-width",
                        attrs: { "label-width": "0" }
                      },
                      [
                        _c("cargo-rich-textarea", {
                          staticStyle: { height: "110px" },
                          attrs: {
                            "text-chars": 0,
                            "warning-count": -1,
                            "wrap-symbol": "r",
                            "auto-uppercase": _vm.isUppercaseByConfig,
                            "auto-half-word": "",
                            disabled: !_vm.isEdit,
                            no: "10"
                          },
                          model: {
                            value: _vm.form.mark,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "mark", $$v)
                            },
                            expression: "form.mark"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          "label-width": "0",
                          title: _vm.$t("SeaExport.Remarks")
                        }
                      },
                      [_c("span", [_vm._v(_vm._s(_vm.getItemTitle("Remark")))])]
                    ),
                    _c(
                      "el-form-item",
                      {
                        staticClass: "auto-width",
                        attrs: { "label-width": "0" }
                      },
                      [
                        _c("el-input", {
                          attrs: {
                            disabled: !_vm.isEdit,
                            type: "textarea",
                            rows: 5,
                            no: "11"
                          },
                          model: {
                            value: _vm.form.remarks,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "remarks", $$v)
                            },
                            expression: "form.remarks"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            ),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: !_vm.showISF,
                    expression: "!showISF"
                  }
                ],
                staticClass: "section form-column"
              },
              [
                _c(
                  "el-form",
                  {
                    staticStyle: { height: "100%" },
                    attrs: {
                      disabled: _vm.readonly,
                      "label-width": "120px",
                      "label-position": "right"
                    }
                  },
                  [
                    _c(
                      "span",
                      {
                        staticClass: "title",
                        attrs: {
                          title: _vm.$t("SeaExport.TransportationInformation")
                        }
                      },
                      [_vm._v(_vm._s(_vm.getItemTitle("Shipping Information")))]
                    ),
                    (_vm.isTradetech || _vm.isEFreight) && _vm.tabName === "ams"
                      ? _c(
                          "el-form-item",
                          {
                            class: _vm.isDifferent("hblNbr2"),
                            attrs: {
                              id: "hblNbr2",
                              label: _vm.amsTitle,
                              title: _vm.amsTitleCn
                            }
                          },
                          [
                            _c(
                              "span",
                              { attrs: { slot: "label" }, slot: "label" },
                              [
                                _c(
                                  "el-tooltip",
                                  {
                                    attrs: {
                                      content: _vm.isEFreight
                                        ? _vm.$t(
                                            "CargoMsg.Cargo_AmsNoEFreightTooltip"
                                          )
                                        : _vm.$t("CargoMsg.Cargo_AmsNoTooltip"),
                                      placement: "right-end"
                                    }
                                  },
                                  [
                                    _c("i", {
                                      staticClass: "el-icon-warning",
                                      staticStyle: {
                                        cursor: "pointer",
                                        color: "#1F75D5"
                                      }
                                    })
                                  ]
                                ),
                                _vm._v(" " + _vm._s(_vm.amsTitle) + " ")
                              ],
                              1
                            ),
                            _c("cargo-rich-textarea", {
                              staticStyle: { "min-height": "0px" },
                              attrs: {
                                "is-trim": true,
                                disabled: _vm.readonly,
                                "warning-count": 12,
                                no: "12"
                              },
                              on: { change: _vm.hblNbr2Change },
                              model: {
                                value: _vm.form.hblNbr2,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "hblNbr2", $$v)
                                },
                                expression: "form.hblNbr2"
                              }
                            })
                          ],
                          1
                        )
                      : _c(
                          "el-form-item",
                          {
                            class: _vm.isDifferent("hblNbr2"),
                            attrs: {
                              label: _vm.amsTitle,
                              title: _vm.amsTitleCn
                            }
                          },
                          [
                            _c("el-input", {
                              attrs: { no: "13" },
                              on: { input: _vm.hblNbr2Change },
                              model: {
                                value: _vm.form.hblNbr2,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "hblNbr2", $$v)
                                },
                                expression: "form.hblNbr2"
                              }
                            })
                          ],
                          1
                        ),
                    _c(
                      "el-form-item",
                      {
                        class: _vm.isDifferent("mbl"),
                        attrs: {
                          label: _vm.getItemTitle("MB/L NO"),
                          title: _vm.$t("SeaExport.MBLNumber")
                        }
                      },
                      [
                        _c("el-input", {
                          attrs: { no: "14" },
                          model: {
                            value: _vm.form.mbl,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "mbl", $$v)
                            },
                            expression: "form.mbl"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.tabName !== "ams",
                            expression: "tabName !== 'ams'"
                          }
                        ],
                        attrs: {
                          label: _vm.getItemTitle("CCN#"),
                          title: _vm.$t("SeaExport.CCNNumber")
                        }
                      },
                      [
                        _c("el-input", {
                          attrs: { no: "15" },
                          model: {
                            value: _vm.form.mblNbr2,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "mblNbr2", $$v)
                            },
                            expression: "form.mblNbr2"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: !(_vm.jsSendHide && _vm.isAci),
                            expression: "!(jsSendHide && isAci)"
                          }
                        ],
                        class: _vm.isDifferent("vessel"),
                        attrs: {
                          label: _vm.getItemTitle("Vessel"),
                          title: _vm.$t("SeaExport.ShipName")
                        }
                      },
                      [
                        _c("cargo-advance-select", {
                          attrs: {
                            "select-type": _vm.TYPE_NAMES.static_data_Vessel,
                            cache: false,
                            "allow-create": true,
                            filterable: "",
                            "default-value": _vm.form.vessel,
                            "static-options": _vm.localData.vesselList,
                            no: "16"
                          },
                          on: {
                            parentCallBack: function(p) {
                              _vm.pm.onVesselSelectionChange(p)
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        class: _vm.isDifferent("voyageFlight"),
                        attrs: {
                          label: _vm.getItemTitle("Voyage"),
                          title: _vm.$t("SeaExport.Voyage")
                        }
                      },
                      [
                        _c("cargo-rich-textarea", {
                          staticStyle: { "min-height": "unset" },
                          attrs: {
                            disabled: _vm.readonly,
                            "text-chars": 0,
                            "warning-count": _vm.tabName === "ams" ? 5 : 10,
                            "is-trim": true,
                            no: "17"
                          },
                          on: { change: _vm.changeVoyage },
                          model: {
                            value: _vm.form.voyageFlight,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "voyageFlight", $$v)
                            },
                            expression: "form.voyageFlight"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: !(
                              _vm.jsSendHide &&
                              (_vm.isAms || _vm.isAci)
                            ),
                            expression: "!(jsSendHide && (isAms || isAci))"
                          }
                        ],
                        class: _vm.isDifferent("vesselIMO"),
                        attrs: {
                          label: _vm.getItemTitle("IMO"),
                          title: _vm.$t("SeaExport.ShipNumber")
                        }
                      },
                      [
                        _c("el-input", {
                          attrs: { no: "18" },
                          model: {
                            value: _vm.form.vesselIMO,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "vesselIMO", $$v)
                            },
                            expression: "form.vesselIMO"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: !(
                              _vm.jsSendHide &&
                              (_vm.isAms || _vm.isAci)
                            ),
                            expression: "!(jsSendHide && (isAms || isAci))"
                          }
                        ],
                        class: _vm.isDifferent("etd"),
                        attrs: {
                          label: _vm.getItemTitle("ETD"),
                          title: _vm.$t("SeaExport.DateOfDeparture")
                        }
                      },
                      [
                        _c("el-date-picker", {
                          staticStyle: { width: "100%" },
                          attrs: {
                            type: "date",
                            "value-format": "yyyy-MM-dd",
                            no: "19"
                          },
                          model: {
                            value: _vm.form.etd,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "etd", $$v)
                            },
                            expression: "form.etd"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: !(_vm.jsSendHide && _vm.isAci),
                            expression: "!(jsSendHide && isAci)"
                          }
                        ],
                        class: _vm.isDifferent("eta"),
                        attrs: {
                          label: _vm.getItemTitle("ETA"),
                          title: _vm.$t("SeaExport.ArrivalDate")
                        }
                      },
                      [
                        _c("el-date-picker", {
                          staticStyle: { width: "100%" },
                          attrs: {
                            type: "date",
                            "value-format": "yyyy-MM-dd",
                            no: "20"
                          },
                          model: {
                            value: _vm.form.eta,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "eta", $$v)
                            },
                            expression: "form.eta"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.jsSendHide && _vm.isAci,
                            expression: "jsSendHide && isAci"
                          }
                        ],
                        attrs: { label: _vm.getItemTitle("DestinationCountry") }
                      },
                      [
                        _c("cargo-advance-select", {
                          attrs: {
                            no: "54",
                            "select-type": _vm.TYPE_NAMES.basic_data_Country,
                            cache: false,
                            filterable: "",
                            "default-value": _vm.form.cargoDestinationCountry,
                            "filter-tag-names": ["code", "chineseName", "name"],
                            "tag-name": "code",
                            "tag-value": "code"
                          },
                          on: {
                            parentCallBack: function(p) {
                              _vm.form.cargoDestinationCountry = p.value
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.jsSendHide && _vm.isAci,
                            expression: "jsSendHide && isAci"
                          }
                        ],
                        attrs: { label: _vm.getItemTitle("DestinationCity") }
                      },
                      [
                        _c("el-input", {
                          attrs: { no: "57" },
                          model: {
                            value: _vm.form.cargoDestinationCity,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "cargoDestinationCity", $$v)
                            },
                            expression: "form.cargoDestinationCity"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: !(
                              _vm.jsSendHide &&
                              (_vm.isAms || _vm.isAci)
                            ),
                            expression: "!(jsSendHide && (isAms || isAci))"
                          }
                        ],
                        attrs: { label: _vm.getItemTitle("Deliv.Mode") }
                      },
                      [
                        _c("cargo-advance-select", {
                          attrs: {
                            no: "freightTerm",
                            filterable: "",
                            "default-value": _vm.form.freightTermHBL,
                            cache: false,
                            "tag-name": "chineseName",
                            "tag-value": "code",
                            "filter-tag-names": ["code", "chineseName"],
                            "static-options":
                              _vm.SystemConstants.AMS_FREIGHT_TERM
                          },
                          on: {
                            parentCallBack: function(p) {
                              _vm.form.freightTermHBL = p.value
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: !(
                              _vm.jsSendHide &&
                              (_vm.isAms || _vm.isAci)
                            ),
                            expression: "!(jsSendHide && (isAms || isAci))"
                          }
                        ],
                        attrs: {
                          label: _vm.getItemTitle("County of Origin"),
                          title: _vm.$t("SeaExport.CountryOfOrigin")
                        }
                      },
                      [
                        _c("el-input", {
                          attrs: { no: "21" },
                          model: {
                            value: _vm.form.countryOrigin,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "countryOrigin", $$v)
                            },
                            expression: "form.countryOrigin"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.jsSendHide && _vm.isAms,
                            expression: "jsSendHide && isAms"
                          }
                        ],
                        attrs: {
                          label: _vm.getItemTitle("Vessel country flag")
                        }
                      },
                      [
                        _c("cargo-advance-select", {
                          attrs: {
                            no: "53",
                            "select-type": _vm.TYPE_NAMES.basic_data_Country,
                            cache: false,
                            filterable: "",
                            "default-value": _vm.form.nationalityCodeofVessel,
                            "filter-tag-names": ["code", "chineseName", "name"],
                            "tag-name": "code",
                            "tag-value": "code"
                          },
                          on: {
                            parentCallBack: function(p) {
                              _vm.form.nationalityCodeofVessel = p.value
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: !(_vm.jsSendHide && _vm.isAci),
                            expression: "!(jsSendHide && isAci)"
                          }
                        ],
                        attrs: {
                          label: _vm.getItemTitle("Place of Receipt"),
                          title: _vm.$t("SeaExport.BillLadingPlaceOfDispatch")
                        }
                      },
                      [
                        _c("cargo-advance-select", {
                          staticStyle: { flex: "1" },
                          attrs: {
                            "select-type": _vm.TYPE_NAMES.basic_data_Seaport,
                            filterable: "",
                            "default-value": _vm.form.dispatchingPlaceCode,
                            "tag-name": "englishName",
                            no: "22"
                          },
                          on: {
                            parentCallBack: function(p) {
                              _vm.portChange(
                                p,
                                "dispatchingPlaceCode",
                                "dispatchingPlace"
                              )
                            }
                          }
                        }),
                        _c("el-input", {
                          model: {
                            value: _vm.form.dispatchingPlace,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "dispatchingPlace", $$v)
                            },
                            expression: "form.dispatchingPlace"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: !(_vm.jsSendHide && _vm.isAci),
                            expression: "!(jsSendHide && isAci)"
                          }
                        ],
                        class: _vm.isDifferent("loadingPortCode"),
                        attrs: {
                          label: _vm.getItemTitle("Place of Loading"),
                          title: _vm.$t("SeaExport.BillLadingPortOfDeparture")
                        }
                      },
                      [
                        !_vm.jsSendHide
                          ? _c("cargo-advance-select", {
                              attrs: {
                                "select-type":
                                  _vm.TYPE_NAMES.basic_data_Seaport,
                                filterable: "",
                                "default-value": _vm.form.loadingPortCode || "",
                                "tag-name": "englishName",
                                no: "23"
                              },
                              on: {
                                parentCallBack: function(p) {
                                  _vm.portChange(
                                    p,
                                    "loadingPortCode",
                                    "loadingPort"
                                  )
                                }
                              }
                            })
                          : _c("cargo-advance-select", {
                              attrs: {
                                no: "23",
                                "static-options": _vm.localData.jsPortList,
                                "custom-label": function(item) {
                                  return "[" + item.code + "]" + item.name
                                },
                                cache: false,
                                filterable: "",
                                "default-value": _vm.form.loadingPortCode || "",
                                "filter-tag-names": ["name", "code"],
                                "tag-name": "name",
                                "tag-value": "code"
                              },
                              on: {
                                parentCallBack: function(p) {
                                  _vm.portChange2(
                                    p,
                                    "loadingPortCode",
                                    "loadingPort"
                                  )
                                }
                              }
                            }),
                        _c("el-input", {
                          model: {
                            value: _vm.form.loadingPort,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "loadingPort", $$v)
                            },
                            expression: "form.loadingPort"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        class: _vm.isDifferent("dischargingPortCode"),
                        attrs: {
                          label: _vm.getItemTitle("Place of Discharge"),
                          title: _vm.$t("SeaExport.BillLadingPortOfDischarge")
                        }
                      },
                      [
                        !_vm.jsSendHide
                          ? _c("cargo-advance-select", {
                              attrs: {
                                "select-type":
                                  _vm.TYPE_NAMES.basic_data_Seaport,
                                filterable: "",
                                "default-value":
                                  _vm.form.dischargingPortCode || "",
                                "tag-name": "englishName",
                                no: "24"
                              },
                              on: {
                                parentCallBack: function(p) {
                                  _vm.portChange(
                                    p,
                                    "dischargingPortCode",
                                    "dischargingPort"
                                  )
                                }
                              }
                            })
                          : _c("cargo-advance-select", {
                              attrs: {
                                no: "24",
                                "static-options":
                                  _vm.localData.jsAmsDischargingList,
                                "custom-label": function(item) {
                                  return "[" + item.code + "]" + item.name
                                },
                                cache: false,
                                "default-value":
                                  _vm.form.dischargingPortCode || "",
                                filterable: "",
                                clearable: "",
                                "filter-tag-names": ["name", "code"],
                                "tag-name": "name",
                                "tag-value": "code"
                              },
                              on: {
                                parentCallBack: function(p) {
                                  _vm.portChange2(
                                    p,
                                    "dischargingPortCode",
                                    "dischargingPort"
                                  )
                                }
                              }
                            }),
                        _c("el-input", {
                          model: {
                            value: _vm.form.dischargingPort,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "dischargingPort", $$v)
                            },
                            expression: "form.dischargingPort"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: !_vm.jsSendHide,
                            expression: "!(jsSendHide)"
                          }
                        ],
                        class: _vm.isDifferent("destinationPortCode"),
                        attrs: {
                          label: _vm.getItemTitle("Place Of Delivery"),
                          title: _vm.$t("SeaExport.BillLadingPlaceOfDelivery")
                        }
                      },
                      [
                        _c("cargo-advance-select", {
                          attrs: {
                            "select-type": _vm.TYPE_NAMES.basic_data_Seaport,
                            filterable: "",
                            "default-value": _vm.form.destinationPortCode || "",
                            "tag-name": "englishName",
                            no: "25"
                          },
                          on: {
                            parentCallBack: function(p) {
                              _vm.portChange(
                                p,
                                "destinationPortCode",
                                "destinationPort"
                              )
                            }
                          }
                        }),
                        _c("el-input", {
                          model: {
                            value: _vm.form.destinationPort,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "destinationPort", $$v)
                            },
                            expression: "form.destinationPort"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: !(_vm.jsSendHide && _vm.isAci),
                            expression: "!(jsSendHide && isAci)"
                          }
                        ],
                        attrs: { title: _vm.$t("SeaExport.LastOverseasPort") }
                      },
                      [
                        _c(
                          "span",
                          { attrs: { slot: "label" }, slot: "label" },
                          [
                            _c(
                              "el-tooltip",
                              {
                                attrs: {
                                  content: _vm.$t(
                                    "CargoMsg.Cargo_LastOverseasPort"
                                  ),
                                  placement: "right-end"
                                }
                              },
                              [
                                _c("i", {
                                  staticClass: "el-icon-warning",
                                  staticStyle: {
                                    cursor: "pointer",
                                    color: "#1F75D5"
                                  }
                                })
                              ]
                            ),
                            _vm._v(
                              " " +
                                _vm._s(_vm.getItemTitle("Last Foreign Port")) +
                                " "
                            )
                          ],
                          1
                        ),
                        !_vm.jsSendHide
                          ? _c("cargo-advance-select", {
                              attrs: {
                                filterable: "",
                                "select-type":
                                  _vm.TYPE_NAMES.basic_data_Seaport,
                                "default-value": _vm.form.lastAbroadProd,
                                no: "26"
                              },
                              on: {
                                parentCallBack: function(p) {
                                  _vm.portChange(
                                    p,
                                    "lastAbroadProd",
                                    "lastAbroadProdName"
                                  )
                                }
                              }
                            })
                          : _c("cargo-advance-select", {
                              attrs: {
                                no: "26",
                                "static-options": _vm.localData.jsPortList,
                                "custom-label": function(item) {
                                  return "[" + item.code + "]" + item.name
                                },
                                cache: false,
                                "default-value": _vm.form.lastAbroadProd,
                                filterable: "",
                                "filter-tag-names": ["name", "code"],
                                "tag-name": "name",
                                "tag-value": "code"
                              },
                              on: {
                                parentCallBack: function(p) {
                                  _vm.portChange2(
                                    p,
                                    "lastAbroadProd",
                                    "lastAbroadProdName"
                                  )
                                }
                              }
                            }),
                        _c("el-input", {
                          model: {
                            value: _vm.form.lastAbroadProdName,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "lastAbroadProdName", $$v)
                            },
                            expression: "form.lastAbroadProdName"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: !(
                              _vm.jsSendHide &&
                              (_vm.isAci || _vm.isAms)
                            ),
                            expression: "!(jsSendHide && (isAci || isAms))"
                          }
                        ],
                        attrs: { title: _vm.$t("SeaExport.FirstPortOfCall") }
                      },
                      [
                        _c(
                          "span",
                          { attrs: { slot: "label" }, slot: "label" },
                          [
                            _c(
                              "el-tooltip",
                              {
                                attrs: {
                                  content: _vm.$t(
                                    "CargoMsg.Cargo_FirstPortOfCall"
                                  ),
                                  placement: "right-end"
                                }
                              },
                              [
                                _c("i", {
                                  staticClass: "el-icon-warning",
                                  staticStyle: {
                                    cursor: "pointer",
                                    color: "#1F75D5"
                                  }
                                })
                              ]
                            ),
                            _vm._v(
                              " " +
                                _vm._s(_vm.getItemTitle("First Port of Call")) +
                                " "
                            )
                          ],
                          1
                        ),
                        _c("cargo-advance-select", {
                          attrs: {
                            filterable: "",
                            "select-type": _vm.TYPE_NAMES.basic_data_Seaport,
                            "default-value": _vm.form.firstPortOfCallCode,
                            no: "27"
                          },
                          on: {
                            parentCallBack: function(p) {
                              _vm.portChange(
                                p,
                                "firstPortOfCallCode",
                                "firstPortOfCall"
                              )
                            }
                          }
                        }),
                        _c("el-input", {
                          model: {
                            value: _vm.form.firstPortOfCall,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "firstPortOfCall", $$v)
                            },
                            expression: "form.firstPortOfCall"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: !(
                              _vm.jsSendHide &&
                              (_vm.isAms || _vm.isAci)
                            ),
                            expression: "!(jsSendHide && (isAms || isAci))"
                          }
                        ],
                        attrs: {
                          label: _vm.getItemTitle("ETA First Port Of Call"),
                          title: _vm.$t("SeaExport.ETAFirstPortOfCall")
                        }
                      },
                      [
                        _c("el-date-picker", {
                          staticStyle: { width: "100%" },
                          attrs: {
                            type: "date",
                            "value-format": "yyyy-MM-dd",
                            no: "49"
                          },
                          model: {
                            value: _vm.form.etaFirstPortOfCall,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "etaFirstPortOfCall", $$v)
                            },
                            expression: "form.etaFirstPortOfCall"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.tabName === "eManifest",
                            expression: "tabName === 'eManifest'"
                          }
                        ],
                        attrs: { label: _vm.getItemTitle("Disch Sub Loc") }
                      },
                      [
                        _c(
                          "div",
                          { staticStyle: { display: "flex" } },
                          [
                            _c("el-input", {
                              staticStyle: {
                                width: "120px",
                                "margin-right": "4px"
                              },
                              attrs: { disabled: "", no: "28" },
                              model: {
                                value: _vm.localData.dishSubLocStr,
                                callback: function($$v) {
                                  _vm.$set(_vm.localData, "dishSubLocStr", $$v)
                                },
                                expression: "localData.dishSubLocStr"
                              }
                            }),
                            _c(
                              "el-button",
                              {
                                attrs: { type: "primary", no: "29" },
                                on: {
                                  click: function($event) {
                                    return _vm.selectSubLoc(1)
                                  }
                                }
                              },
                              [_vm._v(_vm._s(_vm.$t("SeaExport.Select")))]
                            )
                          ],
                          1
                        )
                      ]
                    ),
                    _c(
                      "el-form-item",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.tabName === "eManifest",
                            expression: "tabName === 'eManifest'"
                          }
                        ],
                        attrs: { label: _vm.getItemTitle("Dest Sub Loc") }
                      },
                      [
                        _c(
                          "div",
                          { staticStyle: { display: "flex" } },
                          [
                            _c("el-input", {
                              staticStyle: {
                                width: "120px",
                                "margin-right": "4px"
                              },
                              attrs: { disabled: "", no: "30" },
                              model: {
                                value: _vm.localData.subLocationCodeStr,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.localData,
                                    "subLocationCodeStr",
                                    $$v
                                  )
                                },
                                expression: "localData.subLocationCodeStr"
                              }
                            }),
                            _c(
                              "el-button",
                              {
                                attrs: { type: "primary", no: "31" },
                                on: {
                                  click: function($event) {
                                    return _vm.selectSubLoc(2)
                                  }
                                }
                              },
                              [_vm._v(_vm._s(_vm.$t("SeaExport.Select")))]
                            )
                          ],
                          1
                        )
                      ]
                    )
                  ],
                  1
                )
              ],
              1
            ),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.showISF,
                    expression: "showISF"
                  }
                ],
                staticClass: "section app-main-content",
                staticStyle: { height: "100%" }
              },
              [
                _c("span", { staticClass: "title" }, [_vm._v("ISF")]),
                _c(
                  "div",
                  { staticClass: "tabs-container" },
                  [
                    _c(
                      "el-tabs",
                      {
                        attrs: { type: "card" },
                        model: {
                          value: _vm.activeTabName,
                          callback: function($$v) {
                            _vm.activeTabName = $$v
                          },
                          expression: "activeTabName"
                        }
                      },
                      [
                        _c(
                          "el-tab-pane",
                          {
                            attrs: { name: "tabBookingISF10", label: "ISF10" }
                          },
                          [
                            _c("tab-i-s-f10", {
                              ref: "tabBookingISF10",
                              attrs: {
                                "cargo-doc": _vm.form,
                                job: _vm.job,
                                "isf-type": 10,
                                "is-edit": _vm.isEdit,
                                "party-name-list": _vm.partyNameList,
                                "local-data": _vm.localData
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-tab-pane",
                          {
                            attrs: { name: "tabBookingISF05", label: "ISF05" }
                          },
                          [
                            _c("tab-i-s-f05", {
                              ref: "tabBookingISF05",
                              attrs: {
                                "cargo-doc": _vm.form,
                                job: _vm.job,
                                "isf-type": 5,
                                "is-edit": _vm.isEdit,
                                "party-name-list": _vm.partyNameList,
                                "local-data": _vm.localData
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ]
            ),
            _c(
              "div",
              { staticClass: "section form-column" },
              [
                _c(
                  "el-form",
                  {
                    staticStyle: { height: "100%" },
                    attrs: {
                      disabled: _vm.readonly,
                      "label-width": "100px",
                      "label-position": "left"
                    }
                  },
                  [
                    _c(
                      "span",
                      {
                        staticClass: "title",
                        attrs: { title: _vm.$t("SeaExport.OtherInformation") }
                      },
                      [_vm._v(_vm._s(_vm.getItemTitle("Other")))]
                    ),
                    _c(
                      "el-form-item",
                      {
                        staticClass: "auto-width",
                        attrs: { "label-width": "0" }
                      },
                      [
                        _c("cargo-ag-grid", {
                          staticStyle: { width: "100%", height: "200px" },
                          attrs: {
                            "grid-options": _vm.ams2.gridOptions,
                            "column-defs": _vm.ams2ColumnDefs,
                            "row-data": _vm.ams2.rowData
                          },
                          on: {
                            gridReady: function(params) {
                              _vm.ams2.gridApi = params.api
                            }
                          }
                        }),
                        _c("div", { staticStyle: { padding: "5px 0" } }, [
                          _c(
                            "div",
                            { staticStyle: { float: "right" } },
                            [
                              _c(
                                "el-button",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.job.signHBL,
                                      expression: "job.signHBL"
                                    }
                                  ],
                                  attrs: {
                                    type: "primary",
                                    title: _vm.$t(
                                      "SeaExport.SynchronizeHBLInformation"
                                    ),
                                    no: "32"
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.pm.btnSynchroClickHandler()
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.getItemTitle("Synchronise HB/L"))
                                  )
                                ]
                              ),
                              _c(
                                "el-button",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: !_vm.job.signHBL,
                                      expression: "!job.signHBL"
                                    }
                                  ],
                                  attrs: {
                                    type: "primary",
                                    title: _vm.$t("SeaExport.Add2"),
                                    no: "33"
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.pm.onAddCargoDoc()
                                    }
                                  }
                                },
                                [_vm._v(_vm._s(_vm.getItemTitle("Add")))]
                              ),
                              _c(
                                "el-button",
                                {
                                  attrs: {
                                    type: "danger",
                                    title: _vm.$t("SeaExport.Delete"),
                                    no: "34"
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.pm.onRemoveCargoDoc()
                                    }
                                  }
                                },
                                [_vm._v(_vm._s(_vm.getItemTitle("Delete")))]
                              )
                            ],
                            1
                          )
                        ])
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.getItemTitle("Carrier SCAC"),
                          title: _vm.$t("SeaExport.ShippingCompanySCAC")
                        }
                      },
                      [
                        _c("el-input", {
                          attrs: {
                            disabled: true,
                            value: _vm.carrierScAc,
                            no: "35"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.getItemTitle("Nvocc SCAC"),
                          title: _vm.$t("SeaExport.NonVesselCarrierSCAC")
                        }
                      },
                      [
                        _vm.tabName === "eManifest" || _vm.tabName === "aci"
                          ? _c(
                              "el-select",
                              {
                                attrs: {
                                  filterable: "",
                                  "allow-create": true,
                                  no: "36"
                                },
                                model: {
                                  value: _vm.form.efNvoccScac,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "efNvoccScac", $$v)
                                  },
                                  expression: "form.efNvoccScac"
                                }
                              },
                              _vm._l(_vm.localData.nvoccScacList, function(
                                item
                              ) {
                                return _c("el-option", {
                                  key: item,
                                  attrs: { label: item, value: item }
                                })
                              }),
                              1
                            )
                          : _c(
                              "el-select",
                              {
                                attrs: {
                                  filterable: "",
                                  "allow-create": true,
                                  no: "37"
                                },
                                model: {
                                  value: _vm.form.nvoccScac,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "nvoccScac", $$v)
                                  },
                                  expression: "form.nvoccScac"
                                }
                              },
                              _vm._l(_vm.localData.nvoccScacList, function(
                                item
                              ) {
                                return _c("el-option", {
                                  key: item,
                                  attrs: { label: item, value: item }
                                })
                              }),
                              1
                            )
                      ],
                      1
                    ),
                    _vm.tabName === "ams" || _vm.tabName === "aci"
                      ? _c(
                          "el-form-item",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: !_vm.jsSendHide,
                                expression: "!jsSendHide"
                              }
                            ],
                            attrs: {
                              title: _vm.$t("SeaExport.DeclarationAccount"),
                              label: _vm.getItemTitle("Sender Account")
                            }
                          },
                          [
                            _vm.tabName === "ams"
                              ? _c(
                                  "el-select",
                                  {
                                    attrs: { no: "38" },
                                    model: {
                                      value: _vm.localData.emainAccountStr,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.localData,
                                          "emainAccountStr",
                                          $$v
                                        )
                                      },
                                      expression: "localData.emainAccountStr"
                                    }
                                  },
                                  _vm._l(
                                    _vm.localData.eFreighsAmsList,
                                    function(item) {
                                      return _c("el-option", {
                                        key: item,
                                        attrs: { label: item, value: item }
                                      })
                                    }
                                  ),
                                  1
                                )
                              : _vm._e(),
                            _vm.tabName === "aci"
                              ? _c(
                                  "el-select",
                                  {
                                    attrs: { no: "39" },
                                    model: {
                                      value: _vm.localData.emainAccountAciStr,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.localData,
                                          "emainAccountAciStr",
                                          $$v
                                        )
                                      },
                                      expression: "localData.emainAccountAciStr"
                                    }
                                  },
                                  _vm._l(
                                    _vm.localData.eFreighsAciList,
                                    function(item) {
                                      return _c("el-option", {
                                        key: item,
                                        attrs: { label: item, value: item }
                                      })
                                    }
                                  ),
                                  1
                                )
                              : _vm._e()
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm.jsSendHide && _vm.isAms
                      ? _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.getItemTitle(
                                "paperless_in_bond_participant"
                              )
                            }
                          },
                          [
                            _c(
                              "el-select",
                              {
                                staticStyle: { width: "120px", float: "right" },
                                attrs: { no: "54" },
                                model: {
                                  value: _vm.form.paperlessInBondParticipant,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.form,
                                      "paperlessInBondParticipant",
                                      $$v
                                    )
                                  },
                                  expression: "form.paperlessInBondParticipant"
                                }
                              },
                              [
                                _c("el-option", {
                                  attrs: { label: "Y", value: 1 }
                                }),
                                _c("el-option", {
                                  attrs: { label: "N", value: 2 }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      : _vm._e(),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.tabName !== "isf",
                            expression: "tabName !== 'isf'"
                          }
                        ]
                      },
                      [
                        _c(
                          "span",
                          {
                            attrs: {
                              title: _vm.$t("SeaExport.DeclarationType")
                            }
                          },
                          [_vm._v(_vm._s(_vm.getItemTitle("Declare Type")))]
                        ),
                        _c(
                          "el-form-item",
                          {
                            staticStyle: { "margin-top": "5px" },
                            attrs: { "label-width": "0" }
                          },
                          [
                            _c(
                              "el-radio-group",
                              {
                                attrs: { no: "40" },
                                model: {
                                  value: _vm.form.frob,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "frob", $$v)
                                  },
                                  expression: "form.frob"
                                }
                              },
                              [
                                _c(
                                  "el-tooltip",
                                  {
                                    staticStyle: { display: "block" },
                                    attrs: {
                                      effect: "dark",
                                      content:
                                        _vm.tabName === "ams"
                                          ? _vm.$t(
                                              "SeaExport.DirectToTheUnitedStates"
                                            )
                                          : _vm.$t("SeaExport.DirectToCanada"),
                                      placement: "right"
                                    }
                                  },
                                  [
                                    _c(
                                      "el-radio",
                                      {
                                        attrs: {
                                          disabled: _vm.readonly,
                                          label: "I",
                                          value: "I"
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.isAci
                                              ? _vm.getAciImportInfo("Import")
                                              : _vm.getItemTitle("Import")
                                          )
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                ),
                                _c(
                                  "div",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: _vm.tabName === "eManifest",
                                        expression: "tabName === 'eManifest'"
                                      }
                                    ]
                                  },
                                  [
                                    _c(
                                      "el-tooltip",
                                      {
                                        staticStyle: { display: "block" },
                                        attrs: {
                                          effect: "dark",
                                          content: _vm.$t(
                                            "SeaExport.ToTheInlandWarehouse"
                                          ),
                                          placement: "right"
                                        }
                                      },
                                      [
                                        _c(
                                          "el-radio",
                                          {
                                            attrs: {
                                              disabled: _vm.readonly,
                                              label: "B",
                                              value: "B"
                                            }
                                          },
                                          [_vm._v("In-Bond")]
                                        )
                                      ],
                                      1
                                    ),
                                    _c(
                                      "el-tooltip",
                                      {
                                        staticStyle: { display: "block" },
                                        attrs: {
                                          effect: "dark",
                                          content: _vm.$t(
                                            "SeaExport.TransferClearancePullToStates"
                                          ),
                                          placement: "right"
                                        }
                                      },
                                      [
                                        _c(
                                          "el-radio",
                                          {
                                            attrs: {
                                              disabled: _vm.readonly,
                                              label: "S",
                                              value: "S"
                                            }
                                          },
                                          [_vm._v("In-Transit")]
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _c(
                                  "el-tooltip",
                                  {
                                    staticStyle: { display: "block" },
                                    attrs: {
                                      effect: "dark",
                                      content: _vm.$t(
                                        "SeaExport.CargoThroughTheUnitedStates"
                                      ),
                                      placement: "right"
                                    }
                                  },
                                  [
                                    _c(
                                      "el-radio",
                                      {
                                        attrs: {
                                          disabled: _vm.readonly,
                                          label: "F",
                                          value: "F"
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.isAci
                                              ? _vm.getAciImportInfo(
                                                  "Foreign cargo remaining on-board"
                                                )
                                              : _vm.getItemTitle(
                                                  "Foreign cargo remaining on-board"
                                                )
                                          )
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.tabName !== "ams",
                                expression: "tabName !== 'ams'"
                              }
                            ]
                          },
                          [
                            _c("el-checkbox", {
                              attrs: {
                                label: _vm.$t("SeaExport.secondGeneration"),
                                no: "41"
                              },
                              model: {
                                value: _vm.secondGenerationCheck,
                                callback: function($$v) {
                                  _vm.secondGenerationCheck = $$v
                                },
                                expression: "secondGenerationCheck"
                              }
                            }),
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: _vm.$t(
                                    "SeaExport.CanadianCustomsRecordNumber"
                                  ),
                                  "label-width": "110px"
                                }
                              },
                              [
                                _c("el-input", {
                                  staticStyle: { width: "60px" },
                                  attrs: { disabled: _vm.readonly, no: "42" },
                                  model: {
                                    value: _vm.form.recordNumber,
                                    callback: function($$v) {
                                      _vm.$set(_vm.form, "recordNumber", $$v)
                                    },
                                    expression: "form.recordNumber"
                                  }
                                }),
                                _c("el-input", {
                                  staticStyle: {
                                    "margin-left": "5px",
                                    width: "125px"
                                  },
                                  attrs: { disabled: _vm.readonly, no: "43" },
                                  model: {
                                    value: _vm.form.efHblNumber,
                                    callback: function($$v) {
                                      _vm.$set(_vm.form, "efHblNumber", $$v)
                                    },
                                    expression: "form.efHblNumber"
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.tabName === "eManifest",
                                expression: "tabName === 'eManifest'"
                              }
                            ]
                          },
                          [
                            _c("el-checkbox", {
                              attrs: {
                                label: _vm.getItemTitle(
                                  "Coload In Self Filing Indicator"
                                ),
                                no: "56"
                              },
                              on: {
                                change:
                                  _vm.handleColoadInSelfFilingIndicatorChange
                              },
                              model: {
                                value: _vm.form.coloadInSelfFilingIndicator,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.form,
                                    "coloadInSelfFilingIndicator",
                                    $$v
                                  )
                                },
                                expression: "form.coloadInSelfFilingIndicator"
                              }
                            }),
                            _vm.form.coloadInSelfFilingIndicator
                              ? _c(
                                  "div",
                                  { staticClass: "self-declaration-fields" },
                                  [
                                    _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          label: _vm.getItemTitle("Name")
                                        }
                                      },
                                      [
                                        _c("cargo-advance-select", {
                                          ref: "partyName",
                                          attrs: {
                                            no: "66",
                                            "static-options":
                                              _vm.selfDeclarationList,
                                            cache: false,
                                            "default-value": _vm.form.partyName,
                                            disabled: !_vm.isEdit,
                                            filterable: "",
                                            clearable: "",
                                            "allow-create": true,
                                            "tag-name": "partyName",
                                            "tag-value": "partyName",
                                            placeholder: _vm.readonly
                                              ? ""
                                              : _vm.$t("SeaExport.Required")
                                          },
                                          on: {
                                            parentCallBack: _vm.handleNameSelect
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          label: _vm.getItemTitle("Code")
                                        }
                                      },
                                      [
                                        _c("el-input", {
                                          attrs: {
                                            maxlength: "40",
                                            placeholder: _vm.readonly
                                              ? ""
                                              : _vm.$t("SeaExport.Required")
                                          },
                                          on: {
                                            input: function($event) {
                                              return _vm.filterInput(
                                                $event,
                                                "partyCode"
                                              )
                                            }
                                          },
                                          model: {
                                            value: _vm.form.partyCode,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.form,
                                                "partyCode",
                                                $$v
                                              )
                                            },
                                            expression: "form.partyCode"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          label: _vm.getItemTitle("Address")
                                        }
                                      },
                                      [
                                        _c("el-input", {
                                          attrs: {
                                            maxlength: "50",
                                            placeholder: _vm.readonly
                                              ? ""
                                              : _vm.$t("SeaExport.Required")
                                          },
                                          on: {
                                            input: function($event) {
                                              return _vm.filterInput(
                                                $event,
                                                "partyAddressLine"
                                              )
                                            }
                                          },
                                          model: {
                                            value: _vm.form.partyAddressLine,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.form,
                                                "partyAddressLine",
                                                $$v
                                              )
                                            },
                                            expression: "form.partyAddressLine"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          label: _vm.getItemTitle("Country"),
                                          title: _vm.$t("SeaExport.Country")
                                        }
                                      },
                                      [
                                        _c(
                                          "div",
                                          { staticStyle: { display: "flex" } },
                                          [
                                            _c("el-input", {
                                              attrs: {
                                                maxlength: "2",
                                                placeholder: _vm.readonly
                                                  ? ""
                                                  : _vm.$t("SeaExport.Required")
                                              },
                                              on: {
                                                input: function($event) {
                                                  return _vm.filterAlphabetOnly(
                                                    $event,
                                                    "partyCountryCode"
                                                  )
                                                }
                                              },
                                              model: {
                                                value:
                                                  _vm.form.partyCountryCode,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.form,
                                                    "partyCountryCode",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "form.partyCountryCode"
                                              }
                                            }),
                                            _c(
                                              "span",
                                              {
                                                staticClass: "center-label",
                                                attrs: {
                                                  title: _vm.$t(
                                                    "SeaExport.Province"
                                                  )
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.getItemTitle("State")
                                                  )
                                                )
                                              ]
                                            ),
                                            _c("el-input", {
                                              attrs: {
                                                maxlength: "2",
                                                placeholder: _vm.readonly
                                                  ? ""
                                                  : _vm.$t("SeaExport.Optional")
                                              },
                                              on: {
                                                input: function($event) {
                                                  return _vm.filterAlphabetOnly(
                                                    $event,
                                                    "partyProvince"
                                                  )
                                                }
                                              },
                                              model: {
                                                value: _vm.form.partyProvince,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.form,
                                                    "partyProvince",
                                                    $$v
                                                  )
                                                },
                                                expression: "form.partyProvince"
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      ]
                                    ),
                                    _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          label: _vm.getItemTitle("City"),
                                          title: _vm.$t("SeaExport.City")
                                        }
                                      },
                                      [
                                        _c(
                                          "div",
                                          { staticStyle: { display: "flex" } },
                                          [
                                            _c("el-input", {
                                              attrs: {
                                                maxlength: "25",
                                                placeholder: _vm.readonly
                                                  ? ""
                                                  : _vm.$t("SeaExport.Optional")
                                              },
                                              on: {
                                                input: function($event) {
                                                  return _vm.filterAlphabetOnly(
                                                    $event,
                                                    "partyCity"
                                                  )
                                                }
                                              },
                                              model: {
                                                value: _vm.form.partyCity,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.form,
                                                    "partyCity",
                                                    $$v
                                                  )
                                                },
                                                expression: "form.partyCity"
                                              }
                                            }),
                                            _c(
                                              "span",
                                              {
                                                staticClass: "center-label",
                                                attrs: {
                                                  title: _vm.$t("SeaExport.ZIP")
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.getItemTitle("Zip")
                                                  )
                                                )
                                              ]
                                            ),
                                            _c("el-input", {
                                              attrs: {
                                                maxlength: "10",
                                                placeholder: _vm.readonly
                                                  ? ""
                                                  : _vm.$t("SeaExport.Optional")
                                              },
                                              on: {
                                                input: function($event) {
                                                  return _vm.filterInput(
                                                    $event,
                                                    "partyZipCode"
                                                  )
                                                }
                                              },
                                              model: {
                                                value: _vm.form.partyZipCode,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.form,
                                                    "partyZipCode",
                                                    $$v
                                                  )
                                                },
                                                expression: "form.partyZipCode"
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                )
                              : _vm._e()
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        ),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.tabName !== "isf",
                expression: "tabName !== 'isf'"
              }
            ],
            staticClass: "section"
          },
          [
            _c(
              "span",
              {
                staticClass: "title",
                attrs: { title: _vm.$t("SeaExport.ContainerInformation") }
              },
              [_vm._v(_vm._s(_vm.getItemTitle("House Container Information")))]
            ),
            _c(
              "div",
              { staticStyle: { display: "flex", "flex-direction": "column" } },
              [
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.isEdit,
                        expression: "isEdit"
                      }
                    ],
                    staticStyle: { padding: "5px 0" }
                  },
                  [
                    _c(
                      "el-button",
                      {
                        attrs: {
                          type: "primary",
                          title: _vm.$t("SeaExport.AddContainerInformation"),
                          no: "44"
                        },
                        on: {
                          click: function($event) {
                            _vm.cargoDocUsageSelectedDialog.visible = true
                          }
                        }
                      },
                      [_vm._v(_vm._s(_vm.getItemTitle("Add")))]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: {
                          type: "primary",
                          title: _vm.$t("SeaExport.RemoveContainerInformation"),
                          no: "45"
                        },
                        on: { click: _vm.removeContainerUsageClickHandler }
                      },
                      [_vm._v(_vm._s(_vm.getItemTitle("Delete")))]
                    )
                  ],
                  1
                ),
                _c("cargo-ag-grid", {
                  staticStyle: { width: "100%", height: "350px" },
                  attrs: {
                    "config-module": "130701",
                    "grid-options": _vm.container.gridOptions,
                    "column-defs": _vm.containerColumnDefs,
                    "row-data": _vm.containerFinalRowData
                  },
                  on: {
                    gridReady: function(params) {
                      _vm.container.gridApi = params.api
                    }
                  }
                })
              ],
              1
            )
          ]
        )
      ]),
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          attrs: {
            visible: _vm.advanceTextDialog.visible,
            title: _vm.advanceTextDialog.title,
            width: "600px",
            "close-on-click-modal": false,
            "close-on-press-escape": false
          },
          on: {
            "update:visible": function($event) {
              return _vm.$set(_vm.advanceTextDialog, "visible", $event)
            }
          }
        },
        [
          _c("cargo-rich-textarea", {
            ref: "advanceTextDialogTextarea",
            staticStyle: { height: "198px" },
            attrs: {
              "text-chars": 0,
              "auto-uppercase": _vm.advanceTextDialog.isUppercase,
              "auto-half-word": _vm.advanceTextDialog.formatObj.autoHalfWord,
              "warning-count": _vm.warningCount,
              disabled: _vm.readonly,
              no: "46"
            },
            model: {
              value: _vm.advanceTextDialog.value,
              callback: function($$v) {
                _vm.$set(_vm.advanceTextDialog, "value", $$v)
              },
              expression: "advanceTextDialog.value"
            }
          }),
          _c(
            "span",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.isEdit,
                      expression: "isEdit"
                    }
                  ],
                  attrs: { type: "primary", no: "47" },
                  on: { click: _vm.finishAdvanceText }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.confirm")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { no: "48" },
                  on: {
                    click: function($event) {
                      _vm.advanceTextDialog.visible = false
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.close")))]
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          attrs: {
            visible: _vm.receiptInfoDialog.visible,
            title: _vm.receiptInfoDialog.title,
            width: "600px",
            "close-on-click-modal": false,
            "close-on-press-escape": false
          },
          on: {
            "update:visible": function($event) {
              return _vm.$set(_vm.receiptInfoDialog, "visible", $event)
            }
          }
        },
        [
          _c("cargo-ag-grid", {
            staticStyle: { height: "350px" },
            attrs: {
              "grid-options": _vm.receiptInfoDialog.gridOptions,
              "column-defs": _vm.receiptInfoDialog.columnDefs,
              "row-data": _vm.receiptInfoDialog.rowData
            },
            on: {
              gridReady: function(params) {
                _vm.receiptInfoDialog.gridApi = params.api
              }
            }
          })
        ],
        1
      ),
      _c("cargo-doc-usage-selected-dialog", {
        attrs: {
          visible: _vm.cargoDocUsageSelectedDialog.visible,
          job: _vm.job,
          "doc-type": _vm.CargoDocConsts.AMS
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.cargoDocUsageSelectedDialog, "visible", $event)
          },
          callback: _vm.cargoDocUsageSelectedDialog.callback
        }
      }),
      _c("ams-log-view-title-dialog", {
        attrs: {
          visible: _vm.amsLogViewTitleDialog.visible,
          "row-data": _vm.amsLogViewTitleDialog.rowData
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.amsLogViewTitleDialog, "visible", $event)
          }
        }
      }),
      _c("afr-address-dialog", {
        attrs: {
          visible: _vm.searchBillNoDialog.visible,
          params: _vm.searchBillNoDialog.params,
          "no-label": _vm.amsTitle,
          "no-title": _vm.amsTitleCn
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.searchBillNoDialog, "visible", $event)
          },
          selected: function(p) {
            _vm.pm.selectionItemHandler(p)
          }
        }
      }),
      _c("select-sub-loc-dialog", {
        attrs: {
          visible: _vm.selectSubLocDialog.visible,
          type: _vm.selectSubLocDialog.type
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.selectSubLocDialog, "visible", $event)
          },
          select: _vm.selectSubLocCallBack,
          close: function() {
            return (_vm.selectSubLocDialog.visible = false)
          }
        }
      }),
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          attrs: {
            visible: _vm.checkDialog.visible,
            title: _vm.checkDialog.title,
            width: "600px",
            "close-on-click-modal": false,
            "close-on-press-escape": false
          },
          on: {
            "update:visible": function($event) {
              return _vm.$set(_vm.checkDialog, "visible", $event)
            }
          }
        },
        [
          _c("cargo-ag-grid", {
            staticStyle: { height: "350px" },
            attrs: {
              "grid-options": _vm.checkDialog.gridOptions,
              "column-defs": _vm.checkDialog.columnDefs,
              "row-data": _vm.checkDialog.rowData,
              "show-side-bar": false
            },
            on: {
              gridReady: function(params) {
                _vm.checkDialog.gridApi = params.api
              }
            }
          })
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          attrs: {
            visible: _vm.receiptDialog.visible,
            title: _vm.receiptDialog.title,
            width: "1000px",
            "close-on-click-modal": false,
            "close-on-press-escape": false
          },
          on: {
            "update:visible": function($event) {
              return _vm.$set(_vm.receiptDialog, "visible", $event)
            }
          }
        },
        [
          _c("cargo-ag-grid", {
            staticStyle: { height: "350px" },
            attrs: {
              "grid-options": _vm.receiptDialog.gridOptions,
              "column-defs": _vm.receiptColumnDefs,
              "row-data": _vm.receiptDialog.rowData,
              "show-side-bar": false
            },
            on: {
              gridReady: function(params) {
                _vm.receiptDialog.gridApi = params.api
              }
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }